import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Financial Statement Function: A functional category used in institutional financial reporting.',
    name: 'Financial Statement Functions',
    partialId: PartialId.Standard.create('func_fs'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
